module.exports = __webpack_public_path__ + "product-compound-capsule-08.jpg?f35edc81f80bff4a9d07c1dbc640b951";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-08.jpg
// module id = 105
// module chunks = 0